module.exports = __webpack_public_path__ + "static/img/1banner.c227ed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/1banner.png
// module id = GaUT
// module chunks = 1